import { NicheListWidgetAlive } from "components/widgets/NicheListWidgetAlive";
import { routes } from "@/common/utils/routes";
import { useTrendingNiches } from "@/common/hooks/useTrendingNiches";
import { FeedModuleContainer } from "../FeedModules/FeedModuleContainer";
import { FeedModuleTypeEnum } from "@/common/services/types";

interface ITrendingNichesModule {
  moduleId: string;
  moduleType: FeedModuleTypeEnum;
}

export const TrendingNichesModule = ({ moduleId, moduleType }: ITrendingNichesModule) => {
  const { trendingNiches, isLoading } = useTrendingNiches();

  if (isLoading || !trendingNiches.length) {
    return null;
  }

  return (
    <FeedModuleContainer moduleId={moduleId} moduleType={moduleType}>
      <NicheListWidgetAlive
        className="trendingNiches"
        title="Trending Niches"
        link={routes.niches()}
        niches={trendingNiches}
        page={1}
      />
    </FeedModuleContainer>
  );
};
